import { motion } from "framer-motion";

const problems = [
  {
    icon: "01",
    title: "En Google aparece tu competencia, no vos.",
    description:
      "Te eligen en el mapa. Y ahí gana el que tiene más reseñas, no el que trabaja mejor.",
  },
  {
    icon: "02",
    title: "Tenés clientes y nunca les volviste a escribir.",
    description:
      "Gente a la que ya le hiciste un buen trabajo y hace un año que no sabe nada de vos.",
  },
  {
    icon: "03",
    title: "El presupuesto que mandaste y nadie volvió a mirar.",
    description:
      "Ya lo mediste, lo cotizaste y lo mandaste. Ahí murió. Ese trabajo ya lo hiciste y no lo cobraste.",
  },
  {
    icon: "04",
    title: "La consulta que entró y se contestó tarde.",
    description:
      "Entran a las diez de la noche, un domingo. El que pregunta no espera: le pregunta al siguiente.",
  },
];

export const ProblemSection = () => {
  return (
    <section className="bg-[#08080A] py-24 lg:py-[140px] relative">
      <div className="container mx-auto px-6 max-w-[1200px]">
        <div className="max-w-3xl mb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="text-[#71717A] font-mono text-[13px] tracking-[0.08em] uppercase mb-6">
              ● EL PROBLEMA
            </p>
            <h2 className="text-[32px] md:text-[44px] lg:text-[56px] font-medium tracking-[-0.03em] leading-[1.05] mb-6 text-[#FAFAFA]">
              ¿Querés más ventas?
            </h2>
            <p className="text-[#A1A1AA] text-[16px] md:text-[17px] leading-[1.6] max-w-[600px]">
              Cuando alguien busca lo que haces, no apareces. Entran consultas a
              cualquier hora y se contestan cuando se puede. Y cuando mandás
              presupuestos, nadie les hace seguimiento.
            </p>
          </motion.div>
        </div>

        <div className="divide-y divide-white/5 border-y border-white/5">
          {problems.map((problem, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{
                duration: 0.6,
                delay: index * 0.08,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-4 md:gap-10 py-10 lg:py-12"
            >
              <span className="text-[28px] font-mono font-medium text-transparent bg-clip-text bg-gradient-to-r from-[#7C3AED] to-[#FB7185] leading-none">
                {problem.icon}
              </span>
              <div className="max-w-[640px]">
                <h3 className="text-[#FAFAFA] text-[22px] md:text-[26px] font-medium tracking-[-0.03em] mb-3 leading-[1.15]">
                  {problem.title}
                </h3>
                <p className="text-[#A1A1AA] text-[15px] md:text-[16px] leading-[1.6]">
                  {problem.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
